function bindExclusiveProductAccordions(container) {
  if (!container || container.dataset.exclusiveAccordionBound === 'true') return;
  container.dataset.exclusiveAccordionBound = 'true';

  container.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('.product__accordion summary');
      if (!summary || !container.contains(summary)) return;

      const details = summary.closest('details');
      if (!details || details.hasAttribute('open')) return;

      container.querySelectorAll('.product__accordion details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    },
    true
  );
}

function initProductAccordions(root = document) {
  const containers = new Set();

  if (root.matches?.('product-info')) containers.add(root);
  root.querySelectorAll('product-info').forEach((node) => containers.add(node));
  if (root.matches?.('.product__info-container')) containers.add(root);
  root.querySelectorAll('.product__info-container').forEach((node) => containers.add(node));

  containers.forEach((container) => bindExclusiveProductAccordions(container));
}

initProductAccordions();
document.addEventListener('DOMContentLoaded', () => initProductAccordions());
document.addEventListener('product-info:loaded', (event) => initProductAccordions(event.target));
document.addEventListener('shopify:section:load', (event) => initProductAccordions(event.target));

let norvegrHighlightsMediaBound = false;

function syncNorvegrHighlightPanels() {
  const highlightBlocks = document.querySelectorAll('.norvegr-highlights');
  if (!highlightBlocks.length) return;

  const desktopHighlights = window.matchMedia('(min-width: 750px)');

  const sync = () => {
    highlightBlocks.forEach((block) => {
      const panels = block.querySelectorAll('[data-norvegr-highlights-panel]');
      const challengerDesktop = desktopHighlights.matches && block.closest('.norvegr-challenger-info');

      panels.forEach((panel) => {
        if (desktopHighlights.matches && challengerDesktop) {
          panel.setAttribute('open', '');
        } else {
          panel.removeAttribute('open');
        }
      });
    });
  };

  sync();

  if (!norvegrHighlightsMediaBound) {
    norvegrHighlightsMediaBound = true;
    desktopHighlights.addEventListener('change', sync);
  }
}

syncNorvegrHighlightPanels();
document.addEventListener('DOMContentLoaded', syncNorvegrHighlightPanels);
document.addEventListener('product-info:loaded', syncNorvegrHighlightPanels);
document.addEventListener('shopify:section:load', syncNorvegrHighlightPanels);

document.addEventListener('click', (event) => {
  const jump = event.target.closest('[data-norvegr-open-details]');
  if (!jump) return;

  const details = document.getElementById(jump.dataset.norvegrOpenDetails);
  if (!details) return;

  event.preventDefault();
  details.open = true;

  if (typeof window.norvegrScrollPastStickyHeader === 'function') {
    window.norvegrScrollPastStickyHeader(details);
  } else {
    details.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});
